<div class="capture-headers-form">
  <h3 class="form-title">{{ 'headerForm.title' | translate }}</h3>

  <ng-container *ngIf="shouldDisplayField('exception_message')">
    <div class="capture-headers-form-item">
      <label for="exceptionMessage">
        {{ 'headerForm.exceptionMessage' | translate }}
        <i class="pi pi-info-circle info-icon" [pTooltip]="'headerForm.exceptionMessageTooltip' | translate"
          tooltipPosition="top"></i>
      </label>

      <p-inputgroup>
        <p-autoComplete inputId="exceptionMessage" [(ngModel)]="exceptionMessage"
          [suggestions]="filteredExceptionOptions" (completeMethod)="filterExceptions($event)"
          (onSelect)="onExceptionSelected($event)" field="label" [dropdown]="true" [autoHighlight]="true"
          [forceSelection]="true" [placeholder]="'headerForm.placeholderException' | translate" maxlength="30" />
      </p-inputgroup>
    </div>
  </ng-container>

  <ng-container *ngIf="shouldDisplayField('supplier_name')">
    <div class="capture-headers-form-item">
      <label for="supplierName">
        {{ 'headerForm.supplierName' | translate }}
        <i class="pi pi-info-circle info-icon" [pTooltip]="'headerForm.supplierNameTooltip' | translate"
          tooltipPosition="top"></i>
      </label>

      <p-inputgroup>
        <p-autoComplete inputId="supplierName" [(ngModel)]="selectedSupplierName" [suggestions]="filteredSuppliers"
          (completeMethod)="filterSuppliers($event)" (onSelect)="onSupplierSelected($event)" [dropdown]="true"
          [autoHighlight]="true" [forceSelection]="true"
          [placeholder]="'headerForm.placeholderSupplierName' | translate" field="name">
          <ng-template let-item pTemplate="item">
            <div *ngIf="item.name !== '__noMatch__'">
              {{ item.name }}
            </div>
            <div *ngIf="item.name === '__noMatch__'" class="no-match-item">
              {{ 'headerForm.noMatchSupplier' | translate }}
            </div>
          </ng-template>
        </p-autoComplete>
      </p-inputgroup>
    </div>
  </ng-container>

  <ng-container *ngIf="shouldDisplayField('supplier_id')">
    <div class="capture-headers-form-item">
      <label for="supplierNumber">
        {{ 'headerForm.supplierNumber' | translate }}
        <i class="pi pi-info-circle info-icon" [pTooltip]="'headerForm.supplierNumberTooltip' | translate"
          tooltipPosition="top"></i>
      </label>

      <p-inputgroup>
        <input pInputText id="supplierNumber" [value]="selectedSupplierNumber" readonly
          [placeholder]="'headerForm.placeholderSupplierNumber' | translate" class="readonly-field" />
      </p-inputgroup>
    </div>
  </ng-container>

  <ng-container *ngIf="headerCaptureDataForm()">
    <ng-container *ngFor="let entry of headerCaptureDataForm().controls | keyvalue; trackBy: trackByKey">
      <ng-container *ngIf="shouldDisplayField(entry.key) && entry.key !== 'supplier_name'">
        <div [formGroup]="getFormGroupByProp(entry.key)"
          class="capture-headers-form-item {{ getFormFieldClassConfidenceByProp(entry.key) }}">
          <label for="{{ entry.key }}">
            {{ INVOICE_FIELD_LABELS[entry.key] || entry.key }}
            <i class="pi pi-info-circle info-icon" [pTooltip]="'tooltips.' + entry.key | translate"
              tooltipPosition="top"></i>
          </label>

          <p-inputgroup>
            <input pInputText id="{{ entry.key }}" formControlName="value" autocomplete="off"
              [placeholder]="'headerForm.enterValue' | translate" />
            <p-inputgroup-addon>
              {{ formatConfidenceValue(getDataConfidenceByProp(entry.key)) }}
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>